import HekateOptionListElement from './HekateOptionListElement';
/**
 * Some hard coded state/region option lists
 */
class OptionListUtil {
}
OptionListUtil.emptyOptionListItem = new HekateOptionListElement({
    displayName: '---Please Select---',
    value: '',
});
OptionListUtil.usStates = [
    new HekateOptionListElement(OptionListUtil.emptyOptionListItem),
    new HekateOptionListElement({ displayName: 'Alabama', value: 'Alabama' }),
    new HekateOptionListElement({ displayName: 'Alaska', value: 'Alaska' }),
    new HekateOptionListElement({ displayName: 'Arizona', value: 'Arizona' }),
    new HekateOptionListElement({ displayName: 'Arkansas', value: 'Arkansas' }),
    new HekateOptionListElement({ displayName: 'California', value: 'California' }),
    new HekateOptionListElement({ displayName: 'Colorado', value: 'Colorado' }),
    new HekateOptionListElement({ displayName: 'Connecticut', value: 'Connecticut' }),
    new HekateOptionListElement({ displayName: 'Delaware', value: 'Delaware' }),
    new HekateOptionListElement({
        displayName: 'District of Columbia',
        value: 'District of Columbia',
    }),
    new HekateOptionListElement({ displayName: 'Florida', value: 'Florida FL' }),
    new HekateOptionListElement({ displayName: 'Georgia', value: 'Georgia' }),
    new HekateOptionListElement({ displayName: 'Guam', value: 'Guam' }),
    new HekateOptionListElement({ displayName: 'Hawaii', value: 'Hawaii' }),
    new HekateOptionListElement({ displayName: 'Idaho', value: 'Idaho' }),
    new HekateOptionListElement({ displayName: 'Illinois', value: 'Illinois' }),
    new HekateOptionListElement({ displayName: 'Indiana', value: 'Indiana' }),
    new HekateOptionListElement({ displayName: 'Iowa', value: 'Iowa' }),
    new HekateOptionListElement({ displayName: 'Kansas', value: 'Kansas' }),
    new HekateOptionListElement({ displayName: 'Kentucky', value: 'Kentucky' }),
    new HekateOptionListElement({ displayName: 'Louisiana', value: 'Louisiana' }),
    new HekateOptionListElement({ displayName: 'Maine', value: 'Maine' }),
    new HekateOptionListElement({ displayName: 'Maryland', value: 'Maryland' }),
    new HekateOptionListElement({ displayName: 'Massachusetts', value: 'Massachusetts' }),
    new HekateOptionListElement({ displayName: 'Michigan', value: 'Michigan' }),
    new HekateOptionListElement({ displayName: 'Minnesota', value: 'Minnesota' }),
    new HekateOptionListElement({ displayName: 'Mississippi', value: 'Mississippi' }),
    new HekateOptionListElement({ displayName: 'Missouri', value: 'Missouri' }),
    new HekateOptionListElement({ displayName: 'Montana', value: 'Montana' }),
    new HekateOptionListElement({ displayName: 'Nebraska', value: 'Nebraska' }),
    new HekateOptionListElement({ displayName: 'Nevada', value: 'Nevada' }),
    new HekateOptionListElement({ displayName: 'New Hampshire', value: 'New Hampshire' }),
    new HekateOptionListElement({ displayName: 'New Jersey', value: 'New Jersey' }),
    new HekateOptionListElement({ displayName: 'New Mexico', value: 'New Mexico' }),
    new HekateOptionListElement({ displayName: 'New York', value: 'New York' }),
    new HekateOptionListElement({ displayName: 'North Carolina', value: 'North Carolina' }),
    new HekateOptionListElement({ displayName: 'North Dakota', value: 'North Dakota' }),
    new HekateOptionListElement({ displayName: 'Ohio', value: 'Ohio' }),
    new HekateOptionListElement({ displayName: 'Oklahoma', value: 'Oklahoma' }),
    new HekateOptionListElement({ displayName: 'Oregon', value: 'Oregon' }),
    new HekateOptionListElement({ displayName: 'Pennsylvania', value: 'Pennsylvania' }),
    new HekateOptionListElement({ displayName: 'Rhode Island', value: 'Rhode Island' }),
    new HekateOptionListElement({ displayName: 'South Carolina', value: 'South Carolina' }),
    new HekateOptionListElement({ displayName: 'South Dakota', value: 'South Dakota' }),
    new HekateOptionListElement({ displayName: 'Tennessee', value: 'Tennessee' }),
    new HekateOptionListElement({ displayName: 'Texas', value: 'Texas' }),
    new HekateOptionListElement({ displayName: 'Utah', value: 'Utah' }),
    new HekateOptionListElement({ displayName: 'Vermont', value: 'Vermont' }),
    new HekateOptionListElement({ displayName: 'Virginia', value: 'Virginia' }),
    new HekateOptionListElement({ displayName: 'Washington', value: 'Washington' }),
    new HekateOptionListElement({ displayName: 'West Virginia', value: 'West Virginia' }),
    new HekateOptionListElement({ displayName: 'Wisconsin', value: 'Wisconsin' }),
    new HekateOptionListElement({ displayName: 'Wyoming', value: 'Wyoming' }),
];
OptionListUtil.canadaProvinces = [
    new HekateOptionListElement(OptionListUtil.emptyOptionListItem),
    new HekateOptionListElement({ displayName: 'Alberta', value: 'Alberta' }),
    new HekateOptionListElement({ displayName: 'British Columbia', value: 'British Columbia' }),
    new HekateOptionListElement({ displayName: 'Manitoba', value: 'Manitoba' }),
    new HekateOptionListElement({ displayName: 'New Brunswick', value: 'New Brunswick' }),
    new HekateOptionListElement({
        displayName: 'Newfoundland and Labrador',
        value: 'Newfoundland and Labrador',
    }),
    new HekateOptionListElement({
        displayName: 'Northwest Territories',
        value: 'Northwest Territories',
    }),
    new HekateOptionListElement({ displayName: 'Nova Scotia', value: 'Nova Scotia' }),
    new HekateOptionListElement({ displayName: 'Nunavut', value: 'Nunavut' }),
    new HekateOptionListElement({ displayName: 'Ontario', value: 'Ontario' }),
    new HekateOptionListElement({
        displayName: 'Prince Edward Island',
        value: 'Prince Edward Island',
    }),
    new HekateOptionListElement({ displayName: 'Quebec', value: 'Quebec' }),
    new HekateOptionListElement({ displayName: 'Saskatchewan', value: 'Saskatchewan' }),
    new HekateOptionListElement({ displayName: 'Yukon', value: 'Yukon' }),
];
export default OptionListUtil;
